
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[certificateId]",
      function () {
        return require("private-next-pages/[certificateId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[certificateId]"])
      });
    }
  